import React, { Fragment, Component } from 'react'
import Avatar from 'react-avatar';

const getProfileImage = (user) => {
    let imageUrl;
    if (user.type.includes('basic')) {
        imageUrl = user.consumerImg;
    }
    if (user.type.includes('trainer')) {
        imageUrl = user.trainerImg;
    }
    if (user.type.includes('corporate') || user.type.includes('brand')) {
        imageUrl = user.brandImg;
    }
    return (<img
        className={imageUrl ? 'profileCoverImg' : 'noCoverImg'} src={imageUrl ? imageUrl : '/assets/img/no-image-available.jpg'}
    />)									
}

const getSmallImage = (user, brand) => {
    let imageUrl;
    if (user.type.includes('trainer')) {
        imageUrl = user.partnerImg;
    }
    if (user.type.includes('corporate') || user.type.includes('brand') && Object.keys(brand).length > 0) {
        imageUrl = brand.logoImgUrl;
    }
    if(!imageUrl) {
        return null;
    }
    return (<img
        className="profileUserImg"
        src={imageUrl
    }
/>)									
}

const getAvtar = (user) => {
    let imageUrl;
    if (user.type.includes('basic')) {
        imageUrl = user.consumerImg;
    }
    if (user.type.includes('trainer')) {
        imageUrl = user.trainerImg;
    }
    if (user.type.includes('corporate') || user.type.includes('brand')) {
        imageUrl = user.brandImg;
    }
    if (imageUrl) {
        return (<Avatar src={imageUrl} size="32" round={true} />)	
    } else {
        let name = []
        if (user.firstName) {
            name.push(user.firstName);
        }
        if (user.lastName) {
            name.push(user.lastName);
        }
        if (name.length > 0) {
            name = name.join(" ");
            return (<Avatar name={name} size="32" round={true} />)	
        } else {
            return (<Avatar src="/assets/img/no-image.png" size="32" round={true} />)	
        }
    }									
}

const getName = (user) => {
    let name;
    if (user.type.includes('corporate') || user.type.includes('brand')) {
        name = user.brandName;
    }
    if (user.type.includes('basic') || user.type.includes('trainer')) {
        let names = []
        if (user.firstName) {
            names.push(user.firstName);
        }
        if (user.lastName) {
            names.push(user.lastName);
        }
        // if (names.length > 0) {
            names = names.join(" ");
        // }
        name =  names;
    }
    return toTitleCase(name) || 'User';
}

const toTitleCase = (phrase) => {
    let capitalize;
    if(phrase) {
        capitalize = phrase
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
    return capitalize;
};

export {
    getProfileImage,
    getSmallImage,
    getAvtar,
    getName
}


// WEBPACK FOOTER //
// ./src/components/social/shared/utils.js